import axios from '@/api/axiosInstance';

export default async function getSubscription(includeSubjects) {
  const response = await axios.get(
    `${process.env.NEXT_PUBLIC_API}/subscriptions/current`,
    {
      params: {
        includeSubjects,
      },
    }
  );
  return response.data;
}
